import React, { useEffect, useRef, useState } from "react";
import { MailIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon } from "lucide-react";
import { MAIL_REVIEWS } from "../lib/data";
export function MailReviewCarousel() {
  const [index, setIndex] = useState(0);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const count = MAIL_REVIEWS.length;
  const goTo = (i: number) => {
    const next = (i + count) % count;
    setIndex(next);
    const scroller = scrollerRef.current;
    if (scroller) {
      const child = scroller.children[next] as HTMLElement | undefined;
      if (child) scroller.scrollTo({
        left: child.offsetLeft,
        behavior: "smooth"
      });
    }
  };
  useEffect(() => {
    const id = setInterval(() => goTo(index + 1), 4500);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);
  const handleScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const children = Array.from(scroller.children) as HTMLElement[];
    const mid = scroller.scrollLeft + scroller.clientWidth / 2;
    let closest = 0;
    let min = Infinity;
    children.forEach((c, i) => {
      const center = c.offsetLeft + c.clientWidth / 2;
      const d = Math.abs(center - mid);
      if (d < min) {
        min = d;
        closest = i;
      }
    });
    if (closest !== index) setIndex(closest);
  };
  return <section className="px-4 py-6" aria-label="Reseñas de compradores" data-id="element-116" data-mp="3oax7gyo66p92">
      <div className="relative" data-id="element-117" data-mp="3k8shqb0uecrp">
        <div ref={scrollerRef} onScroll={handleScroll} className="flex snap-x snap-mandatory gap-3 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-118" data-mp="3k8k4gi0t55fz">
          {MAIL_REVIEWS.map(r => <article key={r.email} className="w-[85%] flex-shrink-0 snap-center rounded-xl border border-slate-200 bg-white shadow-lg" data-id="element-119" data-mp="bsqpi7m4k211">
              <div className="flex items-center gap-2 border-b border-slate-100 px-3 py-2" data-id="element-120" data-mp="70fmgvw38049">
                <MailIcon className="h-4 w-4 text-red-500" data-id="element-121" data-mp="q0v9tasxvylv" />
                <span className="text-xs font-semibold text-slate-500" data-id="element-122" data-mp="uwam3ybatmg6">Gmail</span>
                <span className="ml-auto text-[11px] text-slate-400" data-id="element-123" data-mp="h70f6wpg1qkh">{r.time}</span>
              </div>
              <div className="p-3" data-id="element-124" data-mp="l6r1oo7xtkj7">
                <div className="flex items-center gap-2" data-id="element-125" data-mp="l5zea0ohut40">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0f2c4a] text-sm font-bold text-white" data-id="element-126" data-mp="77rme76behzp">
                    {r.name.charAt(0)}
                  </div>
                  <div className="min-w-0" data-id="element-127" data-mp="3udip4wf0m93b">
                    <p className="truncate text-sm font-bold text-slate-800" data-id="element-128" data-mp="3uetqyqowh6rs">{r.name}</p>
                    <p className="truncate text-[11px] text-slate-400" data-id="element-129" data-mp="29820b7dde9g">{r.email}</p>
                  </div>
                </div>
                <p className="mt-2 text-sm font-semibold text-slate-800" data-id="element-130" data-mp="1sjj9xzyrv7lc">{r.subject}</p>
                <p className="mt-1 text-sm leading-snug text-slate-600" data-id="element-131" data-mp="1wkv3ggkrocyt">{r.preview}</p>
                <div className="mt-2 flex gap-0.5" data-id="element-132" data-mp="3h59pqowc6xzq">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-133" data-mp="3d1lh02vyxwcw" data-mpi={i} />)}
                </div>
              </div>
            </article>)}
        </div>

        <button type="button" onClick={() => goTo(index - 1)} aria-label="Reseña anterior" className="absolute -left-1 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-1.5 text-[#0f2c4a] shadow-md" data-id="element-134" data-mp="3m29wl210g4rw">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-135" data-mp="dn8ee5rnv54t" />
        </button>
        <button type="button" onClick={() => goTo(index + 1)} aria-label="Reseña siguiente" className="absolute -right-1 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-1.5 text-[#0f2c4a] shadow-md" data-id="element-136" data-mp="8pg9mb5x3oj7">
          <ChevronRightIcon className="h-5 w-5" data-id="element-137" data-mp="2ai4ib01bz46d" />
        </button>
      </div>

      <div className="mt-3 flex justify-center gap-1.5" data-id="element-138" data-mp="2cu6ofrc24gq4">
        {MAIL_REVIEWS.map((_, i) => <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Ir a la reseña ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? "w-6 bg-[#8bc34a]" : "w-2 bg-white/50"}`} data-id="element-139" data-mp="2gvs7xvj3jt9a" data-mpi={i} />)}
      </div>
    </section>;
}